// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9ef9619b","977":"471074c1"}[chunkId] + ".chunk.js";
};